import { cn } from "@/lib/utils";

// Select nativo ÚNICO de la plataforma. Existe un Select de Base UI (select.tsx) pero nadie lo usaba;
// las páginas montaban `<select>` nativos con 3 estilos distintos (h-8/h-9, bg-transparent/bg-background).
// Este envuelve el nativo con un único estilo, alineado con el componente Input. Para filtros/formularios.
export function NativeSelect({ className, ...props }: React.ComponentProps<"select">) {
  return (
    <select
      className={cn(
        "h-8 rounded-lg border border-input bg-transparent px-2.5 text-sm outline-none transition-colors focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-input/30",
        className,
      )}
      {...props}
    />
  );
}
